(function(){
  document.querySelectorAll('.sa').forEach(function(r){r.classList.add('js-on')});
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els=document.querySelectorAll('.sa-rv');
  if(!('IntersectionObserver' in window)||reduce){els.forEach(function(e){e.classList.add('in')});}
  else{var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.15});els.forEach(function(e){io.observe(e)});}
  document.querySelectorAll('.sa-starfield').forEach(function(f){
    var n=parseInt(f.getAttribute('data-n')||'70',10),s=7;
    function rnd(){s=(s*9301+49297)%233280;return s/233280}
    for(var i=0;i<n;i++){var d=document.createElement('i');var z=rnd()<.15?3:(rnd()<.5?2:1.4);
      d.style.cssText='left:'+(rnd()*100).toFixed(2)+'%;top:'+(rnd()*70).toFixed(2)+'%;width:'+z+'px;height:'+z+'px;opacity:'+(.3+rnd()*.7).toFixed(2)+';animation-delay:'+(rnd()*4).toFixed(2)+'s;animation-duration:'+(3+rnd()*4).toFixed(2)+'s';
      f.appendChild(d)}
  });
})();
